import { CATEGORY_META } from "../lib/icons";

type Kind = "fresh" | "no-search" | "no-filter";

interface Props {
  kind: Kind;
  query?: string;
  category?: string | null;
}

export function Empty({ kind, query, category }: Props) {
  if (kind === "no-search") {
    return (
      <div className="empty fade-up">
        <div className="empty-mark">No matches</div>
        <h2 className="empty-title">Nothing in the archive answers to "{query}".</h2>
        <p className="empty-body">
          Try a shorter word, or a tag. Search reads summaries, note bodies, and link
          TL;DRs — everything else is metadata.
        </p>
      </div>
    );
  }
  if (kind === "no-filter") {
    const meta = category ? CATEGORY_META[category] : null;
    const label = meta ? meta.plural.toLowerCase() : "captures of that kind";
    const singular = meta ? meta.label.toLowerCase() : "capture of this kind";
    return (
      <div
        className="empty fade-up"
        style={meta ? { ["--cat-color" as string]: meta.color } : undefined}
      >
        <div className="empty-mark">All quiet</div>
        <h2 className="empty-title">No {label}. The category is at rest.</h2>
        <p className="empty-body">
          When you next send the bot a {singular}, it will appear here. Until then,
          nothing.
        </p>
      </div>
    );
  }
  return (
    <div className="empty fade-up">
      <div className="empty-mark">The shelves are empty</div>
      <h2 className="empty-title">A commonplace book begins with a single line.</h2>
      <p className="empty-body">
        Send a message, a link, or a reminder to the bot at <code>@inbox_bot</code> on
        Telegram. Whatever you send will appear here, indexed and re-readable.
      </p>
    </div>
  );
}
